import { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { AdminPublicInfo } from '../../Api/Admin/models'
import { GetCbuResponse } from '../../Api/CBU/models'
import { fetchStaticButton } from '../../Api/Buttons/Buttons'
import { Button } from '../../Api/Buttons/models'
import { addPromo, checkIfPromoUserHasPhone } from '../../Api/LoadPanel/LoadPanel';
import { useGetTimeForHistory } from './useGetTimeForHistory';
import toast from 'react-hot-toast';

interface Props {
    adminInfo: AdminPublicInfo | null
    setForm: (form: any) => void
    setLoading: (loading: boolean) => void
    setDropdownOpen: (dropdownOpen: boolean) => void
    fetchedData: GetCbuResponse | null
    form: any
    loading: boolean
    setHistorial: (historial: any[]) => void
    historial: any[]
    setErrorQuantities: (errorQuantities: number) => void
    errorQuantities: number
    showHistory: boolean
    setShowHistory: (showHistory: boolean) => void
    setSelectedPlayerToUpdate: (selectedPlayerToUpdate: any) => void
    setShowCompletePlayerInfoModal: (showCompletePlayerInfoModal: boolean) => void
}



export const useLoadPromo = ({
    adminInfo,
    setForm,
    setLoading,
    setDropdownOpen,
    fetchedData,
    form,
    loading,
    setHistorial,
    historial,
    setErrorQuantities,
    errorQuantities,
    showHistory,
    setShowHistory,
    setSelectedPlayerToUpdate,
    setShowCompletePlayerInfoModal

}: Props) => {
    const { getTime } = useGetTimeForHistory()

    const [messagesPromo, setMessagesPromo] = useState<Button>({
        id: '',
        name: '',
        category: '',
        createdAt: '',
        updatedAt: '',
        OwnerId: '',
        Messages: []
    })

    const checkIfUserHasPhone = async ({ user }: { user: string }) => {
        try {
            const userHasPhone = await checkIfPromoUserHasPhone(user)
            if (!userHasPhone.data.status) {
                setSelectedPlayerToUpdate(userHasPhone.data.playerInfo)
                setShowCompletePlayerInfoModal(true)
                return;
            }
        } catch (error) {
            console.log(error)
        }
    }


    // CONFIRM ADD COINS WITH PROMO
    const confirmAddPromo = async ({ bonus }: { bonus: number }) => {
        if (loading) { return }
        if (form.quantity < 1) { Swal.fire({ text: 'Debes introducir una cantidad (sin contar la promoción)' }); return }
        if (!form.name) { Swal.fire({ text: 'Debes introducir un nombre de usuario' }); return }
        if (!bonus) { Swal.fire({ text: 'Debes elegir una bonificación.' }); return }
        if (isNaN(Number(form.quantity))) {
            Swal.fire({ text: 'Debes introducir un número válido.' });
            return;
        }

        const formattedQuantity = Number(form.quantity)?.toLocaleString("es-ES", {
            maximumFractionDigits: 2,
        });

        if (adminInfo?.useMaxLoadValue && adminInfo?.maxLoadValue && (Number(form.quantity) >= adminInfo?.maxLoadValue)) {
            Swal.fire({
                html: `¿Estás por cargar <span style="color:var(--primary-color)">${formattedQuantity}</span> fichas al usuario <span style="color:var(--primary-color)">${form.name}</span> con una bonificación de <span style="color:var(--primary-color)">${bonus}%</span>, deseas continuar?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'var(--main-color)',
                confirmButtonText: 'Si, Cargar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    handlePromo({ bonus });
                } else {
                    setLoading(false);
                    return;
                }

            });
        } else {
            handlePromo({ bonus });
        }
    }



    // MAIN FUNCTION
    const handlePromo = async ({ bonus = 10 }: { bonus: number }) => {

        const values = {
            name: form.name?.trim(),
            quantity: form.quantity,
            senderName: form.senderName?.trim(),
            destinationAccountName: form.destinationAccountName?.trim()
        }

        setForm({
            name: '',
            quantity: '',
            senderName: '',
            destinationAccountName: fetchedData?.titular ?? ''
        })

        setLoading(true)
        let finalCharge = Number(form.quantity) + (Number(form.quantity) * bonus / 100)

        const copyMessage = async (text: string) => {
            let updatedMessage = text
                .replaceAll('__CANTIDAD__', finalCharge.toString())
                .replaceAll('__USUARIO__', values.name)
                .replaceAll('__PASSWORD__', adminInfo?.default_users_password ?? 'hola123')
                .replaceAll('__LINK__', `${adminInfo?.pageLink}`)
                .replaceAll('__BONUS__', bonus.toString())
            await navigator.clipboard.writeText(updatedMessage);
        }


        let randomIndex = Math.floor(Math.random() * messagesPromo?.Messages?.length);
        let randomValue = messagesPromo?.Messages[randomIndex];
        if (randomValue) copyMessage(randomValue.text)
        setDropdownOpen(false);

        try {
            const result = await addPromo({
                name: values.name,
                quantity: values.quantity,
                bonus: bonus,
                destinationAccountName: values.destinationAccountName,
                senderName: values.senderName
            })

            if (result?.data?.success) {
                toast.success(`${values.quantity} fichas cargadas a ${values.name} con una bonificación de ${bonus}%`)
                let record = { user: values.name, quantity: finalCharge, hour: getTime(), success: true, info: result.data, type: 'promo' }
                setHistorial([...historial, record])


                if (adminInfo?.currentlyInPromo) {
                    checkIfUserHasPhone({ user: values.name })
                }

            } else {
                let record = { user: values.name, quantity: finalCharge, hour: getTime(), success: false, info: result.data, type: 'promo' }
                setHistorial([...historial, record])
                if (!showHistory) setErrorQuantities(errorQuantities + 1)
                const errorMessage = result?.response?.data?.message ?? 'Ha habido un error. Reinicia e intenta de nuevo.'
                Swal.fire({ icon: 'error', text: errorMessage });
            }

        } catch (error: any) {
            let errorMessage = error?.response?.data?.message ?? 'ERROR: No se ha podido cargar, verifica tu conexión y que tengas fichas disponibles.'
            let record = { user: values.name, quantity: finalCharge, hour: getTime(), success: false, info: errorMessage, type: 'promo' }
            setHistorial([...historial, record])
            if (!showHistory) setErrorQuantities(errorQuantities + 1)
            Swal.fire({ icon: 'error', text: errorMessage });
        } finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        fetchStaticButton('static_bonus').then((res) => {
            setMessagesPromo(res)
        })
    }, [])

    return {
        confirmAddPromo,
        historial,
        errorQuantities,
        showHistory,
        setShowHistory,
        setErrorQuantities
    }




}
